import countryCodes from "../../resources/enums/countryCodes";

import kuzel1 from "../../resources/badges/kuzel-1.svg";
import kuzel5 from "../../resources/badges/kuzel-5.svg";
import kuzel10 from "../../resources/badges/kuzel-10.svg";
import kuzel25 from "../../resources/badges/kuzel-25.svg";
import kuzel50 from "../../resources/badges/kuzel-50.svg";
import kuzel100 from "../../resources/badges/kuzel-100.svg";
import kuzel250 from "../../resources/badges/kuzel-250.svg";
import kuzel500 from "../../resources/badges/kuzel-500.svg";
import countries3 from "../../resources/badges/countries-3.svg";
import countries5 from "../../resources/badges/countries-5.svg";
import countries10 from "../../resources/badges/countries-10.svg";
import firstInCountry from "../../resources/badges/first-in-country.svg";
import nightOwl from "../../resources/badges/night-owl.svg";
import earlyBird from "../../resources/badges/early-bird.svg";
import streak7 from "../../resources/badges/streak-7.svg";
import dayOne from "../../resources/badges/day-one.svg";
import veteran from "../../resources/badges/veteran.svg";
import soloKuzel from "../../resources/badges/solo-kuzel.svg";
import crew4 from "../../resources/badges/crew-4.svg";
import companions10 from "../../resources/badges/companions-10.svg";
import companions25 from "../../resources/badges/companions-25.svg";
import streak14 from "../../resources/badges/streak-14.svg";
import streak30 from "../../resources/badges/streak-30.svg";
import weekend10 from "../../resources/badges/weekend-10.svg";
import allMonths from "../../resources/badges/all-months.svg";
import holiday from "../../resources/badges/holiday.svg";
import marathon5 from "../../resources/badges/marathon-5.svg";
import likes10 from "../../resources/badges/likes-10.svg";
import likes50 from "../../resources/badges/likes-50.svg";
import likesGiven25 from "../../resources/badges/likes-given-25.svg";
import comments10 from "../../resources/badges/comments-10.svg";
import hitKuzel10 from "../../resources/badges/hit-kuzel-10.svg";
import likesGiven100 from "../../resources/badges/likes-given-100.svg";
import likesGiven250 from "../../resources/badges/likes-given-250.svg";
import likesGiven500 from "../../resources/badges/likes-given-500.svg";
import comments50 from "../../resources/badges/comments-50.svg";
import comments100 from "../../resources/badges/comments-100.svg";
import comments250 from "../../resources/badges/comments-250.svg";
import hitKuzel25 from "../../resources/badges/hit-kuzel-25.svg";
import hitKuzel50 from "../../resources/badges/hit-kuzel-50.svg";
import hitKuzel100 from "../../resources/badges/hit-kuzel-100.svg";
import countries15 from "../../resources/badges/countries-15.svg";
import countries20 from "../../resources/badges/countries-20.svg";
import countries30 from "../../resources/badges/countries-30.svg";
import likes100 from "../../resources/badges/likes-100.svg";
import likes250 from "../../resources/badges/likes-250.svg";
import likes500 from "../../resources/badges/likes-500.svg";
import veteran2 from "../../resources/badges/veteran-2.svg";
import veteran3 from "../../resources/badges/veteran-3.svg";
import veteran5 from "../../resources/badges/veteran-5.svg";
import veteran10 from "../../resources/badges/veteran-10.svg";

// kluc musi zodpovedat hodnote 'icon' z backendoveho enumu Achievement
const BADGE_IMAGES = {
    "kuzel-1": kuzel1,
    "kuzel-5": kuzel5,
    "kuzel-10": kuzel10,
    "kuzel-25": kuzel25,
    "kuzel-50": kuzel50,
    "kuzel-100": kuzel100,
    "kuzel-250": kuzel250,
    "kuzel-500": kuzel500,
    "countries-3": countries3,
    "countries-5": countries5,
    "countries-10": countries10,
    "first-in-country": firstInCountry,
    "night-owl": nightOwl,
    "early-bird": earlyBird,
    "streak-7": streak7,
    "day-one": dayOne,
    "veteran": veteran,
    "solo-kuzel": soloKuzel,
    "crew-4": crew4,
    "companions-10": companions10,
    "companions-25": companions25,
    "streak-14": streak14,
    "streak-30": streak30,
    "weekend-10": weekend10,
    "all-months": allMonths,
    "holiday": holiday,
    "marathon-5": marathon5,
    "likes-10": likes10,
    "likes-50": likes50,
    "likes-given-25": likesGiven25,
    "comments-10": comments10,
    "hit-kuzel-10": hitKuzel10,
    "likes-given-100": likesGiven100,
    "likes-given-250": likesGiven250,
    "likes-given-500": likesGiven500,
    "comments-50": comments50,
    "comments-100": comments100,
    "comments-250": comments250,
    "hit-kuzel-25": hitKuzel25,
    "hit-kuzel-50": hitKuzel50,
    "hit-kuzel-100": hitKuzel100,
    "countries-15": countries15,
    "countries-20": countries20,
    "countries-30": countries30,
    "likes-100": likes100,
    "likes-250": likes250,
    "likes-500": likes500,
    "veteran-2": veteran2,
    "veteran-3": veteran3,
    "veteran-5": veteran5,
    "veteran-10": veteran10,
};

export const getBadgeImage = (icon) => BADGE_IMAGES[icon] ?? null;

const COUNTRY_NAMES = countryCodes.reduce((acc, country) => {
    acc[country.code.toLowerCase()] = country.name;
    return acc;
}, {});

/** Z kodu krajiny ("sk") urobi citatelny text ("SK – Slovakia"). */
export const getCountryLabel = (code) => {
    if (!code) return "";

    let name = COUNTRY_NAMES[code.toLowerCase()];
    return name ? `${code.toUpperCase()} – ${name}` : code.toUpperCase();
};

export default BADGE_IMAGES;
